<template>
  <div class="">
    <div style="display: flex; justify-content: flex-end">
      <a-button :loading="exportLoading" @click="exportExcell" style="
          height: 31px;
          border-raduis: 5px;
          margin-right: 10px;
          background: #418a49;
          color: #fff;
        " icon="export">
        Export
      </a-button>

      <a-month-picker class="calender" :default-value="moment(startDate)" placeholder="Select month"
        :disabled-date="disabledDate" format="MMM-YYYY" @change="onChange" />
    </div>
    <div class="pt-3">
      <a-table :columns="columns" :loading="tableLoading" :data-source="tableData" :pagination="pagination"
        class="tableStyle">
        <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>

        <div slot="filterCategoryDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>

        <div slot="filterSupplierDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>
      </a-table>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import XLSX from "xlsx";

const columns = [
  {
    title: "Product Name",
    dataIndex: "brandName",
    key: "brandName",
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.brandName
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  },
  {
    title: "Category",
    dataIndex: "productCategoryName",
    key: "productCategoryName",
    scopedSlots: {
      filterDropdown: 'filterCategoryDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.productCategoryName
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  },
  {
    title: "Supplier",
    dataIndex: "productSupplierName",
    key: "productSupplierName",
    scopedSlots: {
      filterDropdown: 'filterSupplierDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.productSupplierName
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  },
  {
    title: "Opening",
    dataIndex: "opening",
    key: "opening",
    // width: 200,
  },
  {
    title: "Received",
    dataIndex: "received",
    key: "received",
    //  width: 150,
  },
  {
    title: "Sold",
    dataIndex: "sold",
    key: "sold",
    // width: 150,
  },
  //   {
  //     title: 'Expired',
  //     dataIndex: 'expired',
  //     key: 'expired',
  //     // width: 150,
  //   },
  //   {
  //     title: 'Damaged',
  //     dataIndex: 'damaged',
  //     key: 'damaged',
  //     // width: 150,
  //   },
  {
    title: "Adjusted Up",
    dataIndex: "adjustedUpStock",
    key: "adjustedUpStock",
    // width: 150,
  },
  {
    title: "Adjusted Down",
    dataIndex: "adjustmentDownStock",
    key: "adjustmentDownStock",
    // width: 150,
  },
  {
    title: "Transferred Out",
    dataIndex: "transferredStock",
    key: "transferredStock",
    // width: 150,
  },

  {
    title: "Closing",
    dataIndex: "closingStock",
    key: "closingStock",
    // width: 150,
  },
  {
    title: "Closing Value(Ksh)",
    dataIndex: "inventoryValue",
    key: "inventoryValue",
    // width: 150,
  },
  //   {
  //     title: 'Status',
  //     key: 'status',
  //     scopedSlots: { customRender: 'status' },
  //   },

  //   {
  //     title: 'Actions',
  //     key: 'actions',
  //     align: 'center',
  //     scopedSlots: { customRender: 'actions' },
  //   },
];

const data = [
  {
    key: 1,
    brandName: "Bruno Test 1",
    opening: 234,
    received: 345,
    sold: 34,
    expired: 40,
    damaged: 0,
    unaccounted: 6,
    closingStock: 100,
    inventoryValue: "Ksh 2345",
  },
  {
    key: 2,
    brandName: "Bruno Test 2",
    opening: 234,
    received: 345,
    sold: 34,
    expired: 40,
    damaged: 0,
    unaccounted: 6,
    closingStock: 100,
    inventoryValue: "Ksh 2345",
  },
  {
    key: 3,
    brandName: "Bruno Test 3",
    opening: 234,
    received: 345,
    sold: 34,
    expired: 40,
    damaged: 0,
    unaccounted: 6,
    closingStock: 100,
    inventoryValue: "Ksh 2345",
  },
];

export default {
  name: "InventoryReport",
  props: {
    distributionCenter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dateFormat: "YYYY-MM-DD",
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      endDate: moment().endOf("month").format("YYYY-MM-DD"),
      searchText: "",
      data,
      columns,
      product: {},
      tableData: [],
      exportLoading: false,
      pagination: {
        pageSize: 20,
      },
      searchInput: null,
      searchedColumn: '',
      defaultValue: "",
      distributionCenters: [],
      distributionCenterId: "",
      params: {
        page: 1,
        perPage: 20,
        searchBy: {},
        sortBy: {},
      },

      productId: "",
      tableLoading: false,
      rules: {
        productId: [
          {
            required: true,
            message: "Please choose your product",
            trigger: "change",
          },
        ],
        quantity: [
          {
            required: true,
            message: "Please enter your quantity",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^[1-9]\d*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
        sellingPrice: [
          {
            required: true,
            message: "Please enter selling price",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
        purchasePrice: [
          {
            required: true,
            message: "Please enter purchase price",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    displayDistCenter() {
      return this.defaultValue;
    },
  },
  methods: {
    ...mapActions(["getInventoryReport", "getAllDistributionCenters"]),
    moment,
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = '';
    },
    handleSubmit() {
      // console.log(this.formInline);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    disabledDate(current) {
      // Can not select days before today and today
      // return current.isSameOrAfter(moment(), 'month')
      console.log("current | ", current);
      console.log("end | ", moment().endOf("day"));
      return current && current > moment().endOf("day");
    },
    onChange(date) {
      // console.log("date | ", date);
      let month = date.format("M");
      let year = date.format("YYYY");
      this.startDate = moment([year, month - 1]).format(this.dateFormat);
      this.endDate = moment(this.startDate)
        .endOf("month")
        .format(this.dateFormat);
      // console.log("startDate | ", this.startDate);
      // console.log("endDate | ", this.endDate);

      let request_data = {
        id: this.distributionCenter.locationId,
        data: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
      };
      // console.log("request_data 3 | ", request_data)
      this.loadingInventoryReport(request_data);
    },
    generateKeys() {
      return Math.random().toString(36).slice(2);
    },
    showAddProductPage() {
      this.$router.push("/new-product").catch(() => { });
    },
    showAddStockPage() {
      this.$router.push("/add-stock").catch(() => { });
    },
    showEditDetails(data) {
      this.setCatalogInfo(data);
      this.$router.push("/edit-product").catch(() => { });
    },
    showMoreDetailsModal(data) {
      this.setCatalogInfo(data);
      this.$router.push("/product-details").catch(() => { });
    },
    showSuccessAlert(message) {
      this.$notification["success"]({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification["error"]({
        message: message,
      });
    },
    exportExcell() {
      this.exportLoading = true;
      const dataToExport = [
        [
          "Product Name",
          "Opening",
          "Received",
          "Sold",
          "Adjusted Up",
          "Adjusted Down",
          "Transferred Out",
          "Closing",
          "Closing Stock Value",
        ],
      ];
      let request_data = {
        id: this.distributionCenter.locationId,
        data: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
      };

      this.getInventoryReport(request_data).then(
        (response) => {
          this.exportLoading = false;

          // console.log('response in sales | ', response)
          if (response.status === 200) {
            let results = response.data.data;

            results.forEach((v) => {
              dataToExport.push([
                v.productBrandName,
                v.openingStock,
                v.receivedStock,
                v.soldStock,
                v.adjustedUpStock,
                v.adjustmentDownStock,
                v.transferredStock,
                v.closingStock,
                v.remainingInventoryValue,
              ]);
            });

            let wb = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(
              wb,
              `Export-Inventory-Report-${moment().format("DD-MM-YYYY")}.xlsx`
            );
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported");
          } else {
            this.exportLoading = false;
            console.log("Error | ", response);
          }
        },
        (error) => {
          this.exportLoading = false;
          console.log("Error | ", error);
        }
      );
    },
    async loadingInventoryReport(request_data) {
      this.tableLoading = true;
      let response = await this.getInventoryReport(request_data);
      if (response.status === 200) {
        this.tableLoading = false;
        this.tableData = response.data.data.map((report) => ({
          key: report.productId,
          brandName: report.productBrandName,
          opening: report.openingStock,
          received: report.receivedStock,
          sold: report.soldStock,
          productCategoryName: report.productCategoryName,
          productSupplierName: report.productSupplierName,
          adjustedUpStock: report.adjustedUpStock,
          adjustmentDownStock: report.adjustmentDownStock,
          transferredStock: report.transferredStock,
          // expired: report.expiredStock,
          // damaged: report.damagedStock,
          closingStock: report.closingStock,
          inventoryValue: report.remainingInventoryValue.toLocaleString(
            undefined,
            { minimumFractionDigits: 2 }
          ),
        }));
      } else {
        this.tableLoading = false;
        // console.log("Error | ", response)
      }
    },
    loadDefaultData() {
      this.endDate = moment(this.startDate)
        .endOf("month")
        .format(this.dateFormat);
      let request_data = {
        id: this.distributionCenter.locationId,
        data: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
      };
      this.loadingInventoryReport(request_data);
    },
  },
  created() {
    this.loadDefaultData();
  },
};
</script>

<style scoped>
.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>